import ApplicationController from '../../../application_controller'
import Highcharts from 'highcharts'
import { useDispatch } from 'stimulus-use'
require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/map')(Highcharts)
Highcharts.maps['custom/north-america-no-central'] = require('@highcharts/map-collection/custom/north-america-no-central.geo.json')
Highcharts.maps['custom/south-america'] = require('@highcharts/map-collection/custom/south-america.geo.json')
Highcharts.maps['custom/world-palestine-highres'] = require('@highcharts/map-collection/custom/world-palestine-highres.geo.json')
Highcharts.maps['custom/europe'] = require('@highcharts/map-collection/custom/europe.geo.json')
Highcharts.maps['countries/us/custom/us-small'] = require('@highcharts/map-collection/countries/us/custom/us-small.geo.json')

export default class extends ApplicationController {
  DEFAULT_CATEGORIES_AMOUNT = 6

  static values = {
    regionName: String,
    regionData: Array,
    categoriesCount: Number,
    regionBaseCodes: Array,
    seriesColors: Array
  }

  doConnect() {
    useDispatch(this)
  }

  afterConnect() {
    this.initializeHighcharts()
    this.initializeParams()

    if (this.validateParams()) { this.showRegionMap() }
  }

  initializeParams() {
    this.regionName = this.regionNameValue
    this.regionData = this.hasRegionDataValue ? this.regionDataValue : null
    this.categoriesCount = this.hasCategoriesCountValue ? this.categoriesCountValue : this.DEFAULT_CATEGORIES_AMOUNT
    this.regionBaseCodes = this.hasRegionBaseCodesValue ? this.regionBaseCodesValue : null
    this.seriesColors = this.hasSeriesColorsValue ? this.seriesColorsValue : []

    if (!this.hasPointAttributesValue) {
      this.pointAttributesValue = {}
    }

    this.series = RegionDataConverter.convert(
      this.regionData,
      this.regionBaseCodes,
      this.seriesOptions,
      this.categoriesCount
    )
  }

  generateUsStatesSideColumn() {
    if (this.regionName === 'unitedStates') {
      const mapData = Highcharts.geojson(Highcharts.maps['countries/us/custom/us-small'])

      mapData.forEach(p => {
        const path = p.path; const copy = { path: path }
        p.ucName = null
        if (path[0][1] === 9727) {
          Highcharts.seriesTypes.map.prototype.getBox.call({}, [copy])
          p.middleX = ((path[0][1] + path[1][1]) / 2 - copy._minX) / (copy._maxX - copy._minX)
          p.middleY = ((path[0][2] + path[2][2]) / 2 - copy._minY) / (copy._maxY - copy._minY)
          p.ucName = p.properties['hc-a2'].toUpperCase()
        }
      })
      return mapData
    }
    return undefined
  }

  validateParams() {
    const paramsValid = this.regionName && this.regionData
    if (!paramsValid) { console.error(`${this.identifier} Error: Invalid values - missing regionName or regionData value(s)`) }

    return paramsValid
  }

  get regionMapName() {
    const mapName = ({
      northAmerica: 'custom/north-america-no-central',
      southAmerica: 'custom/south-america',
      asiaPacific: 'custom/world-palestine-highres',
      europe: 'custom/europe',
      unitedStates: 'countries/us/custom/us-small'
    })[this.regionName]

    if (!mapName) {
      return 'custom/world-palestine-highres'
    } else {
      return mapName
    }
  }

  get seriesOptions() {
    return {
      mapData: this.generateUsStatesSideColumn(),
      states: {
        hover: {
          color: '#BADA55'
        }
      },
      dataLabels: {
        enabled: true,
        format: '{point.ucName}'
      }
    }
  }

  initializeHighcharts() {
    Highcharts.setOptions({
      chart: {
        style: {
          fontFamily: 'Uni Neue'
        },
        borderWidth: 0
      },
      map: {
        nullColor: '#ffffff'
      },
      exporting: {
        enabled: false
      }
    })
  }

  tooltipFormat(point) {
    let tooltipFormat = ''
    const region = this.point.value
    tooltipFormat += `<span style="font-size:12px"><b>${region.name}</b></span><br>`
    region.data.forEach((object) => {
      tooltipFormat += `<span><b>${object.value}</b> ${object.name}</span><br>`
    })
    return tooltipFormat
  }

  showRegionMap() {
    Highcharts.mapChart(this.element, {
      chart: {
        map: this.regionMapName
      },

      title: {
        text: ''
      },

      colors: this.seriesColors,

      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'top',
        layout: 'horizontal',
        navigation: { enabled: false }
      },
      tooltip: {
        backgroundColor: '#FFFFFF',
        borderColor: '#ADADAD',
        borderRadius: 0,
        headerFormat: '',
        formatter: this.tooltipFormat

      },
      plotOptions: {
        map: {
          allAreas: false,
          dataLabels: {
            enabled: true,
            color: '#FFFFFF',
            borderColor: '#D8D8D8',
            borderRadius: 2,
            style: {
              fontWeight: 'bold'
            }
          }
        },
        series: {
          events: {
            legendItemClick: (e) => {
              e.preventDefault()
            },
            click: (e) => {
              this.dispatch(
                'clicked-point',
                {
                  point: e.point
                }
              )
            }
          },
          animation: false,
          states: {
            hover: {
              enabled: false
            }
          }
        }
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },

      series: this.series
    })
  }
}

// Converts region data into Something Highcharts understands
class RegionDataConverter {
  // Region: Object
  // {
  //    code: String,
  //    name: String,
  //    value: Number,
  //    data: [
  //      { name: String, value: Number },
  //      { name: String, value: Number }, ...
  //    ],
  // }

  // HighchartSerieElem: Object
  // {
  //   'hc-key': String, (matches Region.code in value)
  //   value: Region
  // }

  // HighchartsSerie: Object
  // {
  //    name: String,
  //    data: [ HighchartSerieElem, HighchartSerieElem, ...]
  //  }

  // MAIN METHOD
  // @param regionData {Array} Array of Region objects
  // @param regionBaseCodes {Array} Array of strings containing the region
  //                                codes that should appear on the corresponding map
  // @param seriesOptions {Object} Object to be added in each serie object
  //                               (attributes here will be added as part of each
  //                               HighchartsSerieElem in the HighchartsSerie returned)
  // @return: {Object} HighchartsSerie object will be returned
  static convert(regionData, regionBaseCodes, seriesOptions, groupsAmount) {
    // STEP 1 - Clean region data by removing regions (in regionData)
    //          that doesn't appear in regionBaseCodes
    const cleanRegionData = this.clean(regionData, regionBaseCodes)

    // STEP 2 - Classify the regions in regionData in a set amount of groups/categories.
    //          And, create a serie for each one of the groups.
    const regionDataClassifiedInSeries = this.classify(cleanRegionData, seriesOptions, groupsAmount)

    // STEP 3 - Create a serie including region codes belonging to the map,
    //          but are not in regionData.
    //         This is needed so the regions are rendered in the map.
    //         In addition, this regions need to be rendered with a special styling.
    const serieWithNotIncludedRegions = this.createSerieWithMissingRegions(cleanRegionData, regionBaseCodes, seriesOptions)

    // FINAL STEP - Glue together all categorized series in an array of series and return it.
    return [
      { ...serieWithNotIncludedRegions },
      ...regionDataClassifiedInSeries
    ]
  }

  // ********************************************************************** //
  // Cleans region data by removing regions (in regionData)
  // that doesn't appear in regionBaseCodes
  static clean(regionData, regionBaseCodes) {
    const regionCodes = new Set(regionBaseCodes)
    const region = []

    regionData.forEach(subregion => {
      const subregionCode = subregion.code.toUpperCase()
      if (regionCodes.has(subregionCode)) {
        region.push(subregion)
      }
    })

    return [...region]
  }

  // ********************************************************************** //
  // Classify the regions in regionData in a set amount of groups/categories.
  // And, create a serie for each one of the groups.
  static classify(regionData, seriesOptions, groupsAmount) {
    const roundUpOnMultiple = (number, multiple) => {
      return Math.ceil(number / multiple) * multiple
    }

    //  STEP 1 - get max value in region data
    let maxValueInRegionData = regionData[0].value
    regionData.forEach(elem => {
      maxValueInRegionData = Math.max(maxValueInRegionData, elem.value)
    })

    //  STEP 2 - create min and max limits the series with non-zero values
    const defaultMultipleForSeriesRange = 5

    const roundedMin = 1
    const roundedMax = roundUpOnMultiple(maxValueInRegionData, defaultMultipleForSeriesRange)

    const diff = (roundedMax - roundedMin) / (groupsAmount)
    const roundedDiff = roundUpOnMultiple(diff, defaultMultipleForSeriesRange)

    const roundedMaxFinal = (groupsAmount * roundedDiff) // TODO - change name of var

    // STEP 3 - Create a N amount of of empty series to classify regionData
    //          N = amountOfSeries + 1
    //          (1 is for the series containing regions with zero values)
    const seriesRegionsWithValue = [...this.initializedSeriesWithRegionsValue(roundedMin, roundedDiff, seriesOptions, groupsAmount)]
    const serieWithZeroDataValueRegions = { name: '0', data: [], ...seriesOptions }

    // STEP 4 - Classify regionData in their corresponding serie
    regionData.forEach(elem => {
      const elemValue = elem.value
      const elemKey = elem.code
      const serieElem = this.createSerieElem(elemKey, elem)
      let elementCategoryIndex

      if (elemValue > 0) {
        if (elemValue === roundedMaxFinal) {
          elementCategoryIndex = groupsAmount - 1
        } else {
          elementCategoryIndex = Math.floor((elemValue - roundedMin) / roundedDiff)
        }

        seriesRegionsWithValue[elementCategoryIndex].data.push(serieElem)
      } else {
        serieWithZeroDataValueRegions.data.push(serieElem)
      }
    })

    // STEP 5 - Glue together series generated, and return it.
    return [serieWithZeroDataValueRegions, ...seriesRegionsWithValue]
  }

  static initializedSeriesWithRegionsValue(min, diff, seriesOptions, groupsAmount) {
    const initializedSeries = []
    let serieLowerLimit = min
    let serieHigherLimit = min + diff - 1

    for (let step = 0; step < groupsAmount; step += 1) {
      let serieName
      const isLastSerie = step === groupsAmount - 1

      if (isLastSerie) {
        serieName = `${serieLowerLimit} +`
      } else {
        serieName = `${serieLowerLimit} - ${serieHigherLimit}`
      }

      initializedSeries.push(
        { name: serieName, data: [], ...seriesOptions }
      )

      serieLowerLimit = serieHigherLimit + 1
      serieHigherLimit = serieLowerLimit + diff - 1
    }
    return initializedSeries
  }

  // ********************************************************************** //
  // Create a serie including region codes belonging to the map(included in regionBaseCodes),
  // but are not in regionData.
  static createSerieWithMissingRegions(regionData, regionBaseCodes, seriesOptions) {
    const missingRegionCodes = new Set(regionBaseCodes)
    const formattedMissingRegionData = []

    regionData.forEach(subregion => {
      const subregionCode = subregion.code.toUpperCase()
      if (missingRegionCodes.has(subregionCode)) {
        missingRegionCodes.delete(subregionCode)
      }
    })

    missingRegionCodes.forEach(subregionCode => {
      formattedMissingRegionData.push(this.createSerieElem(subregionCode.toLowerCase(), null))
    })

    return {
      name: 'No FN data',
      data: [...formattedMissingRegionData],
      dashStyle: 'dot',
      style: { backgroundColor: 'transparent' },
      ...seriesOptions
    }
  }

  // ********************************************************************** //
  // Create a serie element understood by Highcharts Maps
  static createSerieElem = (key, value, other = {}) => {
    return { 'hc-key': key, value: value, ...other }
  }
}
